import { Skeleton } from '../shadcn'

export const BaseDialogSkeleton = () => {
  return (
    <div>
      {Array.from({ length: 3 }).map((_, idx) => (
        <div key={idx} className="mb-6 last:mb-0">
          <Skeleton className="h-6 w-1/2 rounded-xl mb-2" />
          <Skeleton className="h-9 w-full rounded-xl" />
        </div>
      ))}
      <Skeleton className="h-26 w-full rounded-xl mb-6" />
      <Skeleton className="h-27 w-full rounded-xl" />
    </div>
  )
}
